import {
    isFeatureEnabled,
    toFeatureState,
} from '@etrigan/feature-toggles-client'
import { TheWestSection } from '@news-mono/common'
import { metrics, ResponsivePictureLayout } from '@news-mono/component-library'
import {
    getResolvedTopicPageMeta,
    StaticRoutes,
    Topic,
} from '@news-mono/web-common'
import { get as getCookie, set as setCookie } from 'js-cookie'
import { layout } from '../../../App.routing'
import { billboardLeaderboardMrec } from '../../ad-units'

export let desktopLandingBanner1x = require('./assets/BAY2023/bannerDesktop@1x.png')
export let desktopLandingBanner2x = require('./assets/BAY2023/bannerDesktop@2x.png')

export let mobileLandingBanner1x = require('./assets/BAY2023/bannerMobile@1x.png')
export let mobileLandingBanner2x = require('./assets/BAY2023/bannerMobile@2x.png')

export let tabletLandingBanner1x = require('./assets/BAY2023/bannerTablet@1x.png')
export let tabletLandingBanner2x = require('./assets/BAY2023/bannerTablet@2x.png')

export let socialShareImage = require('./assets/BAY2023/SocialImage.png')

export const bestAustralianYarnRoute: StaticRoutes<TheWestSection> = {
    '/lifestyle/best-australian-yarn': ({
        getAdTargeting,
        store,
        config,
        resolution,
    }) => {
        const canonicalUrl =
            config.publicUrl + '/lifestyle/best-australian-yarn'

        const topic: Topic = {
            id:
                getResolvedTopicPageMeta(resolution)?.id ||
                'lifestyle/best-australian-yarn',
            metadata: {},
            title:
                getResolvedTopicPageMeta(resolution)?.title ||
                getResolvedTopicPageMeta(resolution)?.seoTitle ||
                'Best Australian Yarn 2023',
            seoTitle: getResolvedTopicPageMeta(resolution)?.seoTitle || '',
            seoDescription:
                getResolvedTopicPageMeta(resolution)?.seoDescription || ``,
        }

        if (
            isFeatureEnabled(
                toFeatureState(store.getState().toggles),
                'BAY-top-14',
            )
        ) {
            desktopLandingBanner1x = require('./assets/BAY2023/bannerDesktop@1x.png')
            desktopLandingBanner2x = require('./assets/BAY2023/bannerDesktop@2x.png')

            mobileLandingBanner1x = require('./assets/BAY2023/bannerMobile@1x.png')
            mobileLandingBanner2x = require('./assets/BAY2023/bannerMobile@2x.png')

            tabletLandingBanner1x = require('./assets/BAY2023/bannerTablet@1x.png')
            tabletLandingBanner2x = require('./assets/BAY2023/bannerTablet@2x.png')

            socialShareImage = require('./assets/BAY2023/SocialImage.png')
        }
        const getSocialImageMeta = [
            {
                property: 'og:image',
                content: socialShareImage,
            },
            { name: 'twitter:image', content: socialShareImage },
            {
                property: 'og:image:height',
                content: '643',
            },
            {
                property: 'og:image:width',
                content: '1224',
            },
            {
                property: 'og:description',
                content: topic.seoDescription,
            },
            {
                property: 'twitter:description',
                content: topic.seoDescription,
            },
        ]

        const isEnabled = isFeatureEnabled(
            toFeatureState(store.getState().toggles),
            'best-australian-yarn-route',
            true,
        )

        const baySeedVal = store.getState().misc.baySeed

        if (
            typeof window !== 'undefined' &&
            baySeedVal &&
            !getCookie('bayseed')
        ) {
            setCookie('bayseed', baySeedVal)
        }

        if (!isEnabled) {
            return null
        }

        return {
            kind: 'page',
            heading: topic.title,
            pageType: 'topic',
            hideHeading: true,
            refreshOnInactive: false,
            pageMeta: {
                title: topic.title,
                description: topic.seoDescription,
                seoTitle: topic.seoTitle,
                seoDescription: topic.seoDescription,
                link: [{ rel: 'canonical', href: canonicalUrl }],
                meta: getSocialImageMeta,
            },
            adTargeting: getAdTargeting('home', 'default', topic),
            section: 'default',
            compositions: [
                layout.composition({
                    type: 'thor',
                    props: {
                        containerWidth:
                            metrics.thewest.siteMetrics.mainContentWidth,
                        horizontalGutters: true,
                    },
                    contentAreas: {
                        main: [
                            layout.component({
                                type: 'image-banner',
                                props: {
                                    defaultSrc: desktopLandingBanner2x,
                                    verticalGutters: ['unset', 'unset'],
                                    altText: 'Best Australian Yarn - Top 50',
                                    sources: [
                                        {
                                            breakpoint: 'md',
                                            src: [
                                                {
                                                    src: desktopLandingBanner1x,
                                                    density: '1x',
                                                },
                                                {
                                                    src: desktopLandingBanner2x,
                                                    density: '2x',
                                                },
                                            ],
                                        },
                                        {
                                            breakpoint: 'sm',
                                            src: [
                                                {
                                                    src: tabletLandingBanner1x,
                                                    density: '1x',
                                                },
                                                {
                                                    src: tabletLandingBanner2x,
                                                    density: '2x',
                                                },
                                            ],
                                        },
                                        {
                                            src: [
                                                {
                                                    src: mobileLandingBanner1x,
                                                    density: '1x',
                                                },
                                                {
                                                    src: mobileLandingBanner2x,
                                                    density: '2x',
                                                },
                                            ],
                                        },
                                    ],
                                },
                            }),
                            layout.nestedComposition({
                                type: 'thor',
                                feature:
                                    'best-australian-yarn-curation-segment',
                                props: {
                                    hasBackgroundFill: true,
                                    containerWidth: '100%',
                                    verticalGutters: true,
                                    horizontalGutters: true,
                                    verticalSpacing: 'lg',
                                    themeOverride: 'best-australian-yarn',
                                    hideFeatureHeader: true,
                                },
                                contentAreas: {
                                    main: [
                                        layout.component({
                                            type: 'sierra',
                                            props: {
                                                verticalSpacing: 'gridGap',
                                                fixedRatios: ['16:9'],
                                                heroImageLayout:
                                                    ResponsivePictureLayout.ObjectFitContain,
                                                cardOrientation: {
                                                    type: 'Landscape-Portrait',
                                                    maxBreakpoint: 'md',
                                                },
                                                cardLayout: [
                                                    'the-west-hero-lgNoBorder',
                                                    'hero-support',
                                                    'hero-support',
                                                ],
                                                dataDefinitionArgs: {
                                                    type: 'curation',
                                                    name: 'best-australian-yarn-feature-page',
                                                    offset: 0,
                                                    pageSize: 3,
                                                },
                                            },
                                        }),
                                    ],
                                },
                            }),
                            layout.component({
                                type: 'lima',
                                feature: 'BAY-top-14',
                                props: {
                                    verticalSpacing: 'xl',
                                    fontScale: 0.75,
                                    fixedRatios: ['16:9'],
                                    hasBackground: true,
                                    kickerMode: 'hidden',
                                    initialColumns: 1,
                                    intermediateColumns: 2,
                                    finalColumns: 4,
                                    cardOrientation: {
                                        type: 'Landscape-Portrait',
                                    },
                                    hideByline: true,
                                    hideBottomBorder: true,
                                    sectionHeader: {
                                        heading: "The Winner's Circle",
                                        section: 'lifestyle',
                                    },
                                    dataDefinitionArgs: {
                                        type: 'curation',
                                        name: 'best-australian-yarn-feature-page',
                                        offset: 3,
                                        pageSize: 14,
                                    },
                                },
                            }),
                            ...billboardLeaderboardMrec('one'),
                            layout.component({
                                type: 'lima',
                                props: {
                                    verticalSpacing: 'md',
                                    fontScale: 1.2,
                                    fixedRatios: ['16:9'],
                                    initialColumns: 1,
                                    intermediateColumns: 2,
                                    finalColumns: 4,
                                    hasBackground: true,
                                    loadMoreEnabled: true,
                                    sectionHeader: {
                                        heading: 'Latest News',
                                    },

                                    dataDefinitionArgs: {
                                        type: 'listing',
                                        topics: [
                                            'lifestyle/best-australian-yarn',
                                        ],
                                        includeSubTopics: true,
                                        paging: {
                                            page: 1,
                                            pageSize: 8,
                                            pageOffset: 0,
                                        },
                                    },
                                },
                            }),
                        ],
                        sidebar: [],
                    },
                }),
            ],
        }
    },
}
